<template>
  <div>
    <el-container>
      <!--头部-->
      <el-header style='display: flex;justify-content: space-between'>
        <div class='leftBox'>
          <el-button :class="!isCollapse?'toggle-button el-icon-s-fold':'toggle-button el-icon-s-unfold'"
                     @click='isCollapse = !isCollapse'><span class=''></span></el-button>
          <div class='logo'>
            <img src='@/assets/logo.png' alt />
          </div>
          <!--<div class="left">
            &lt;!&ndash;<el-tag @click="home">首页</el-tag>&ndash;&gt;
            <el-tag
                :class="{ cutton: item.activePath === activePath }"
                v-for="(item, index) in tabList"
                :key="index"
                @click="switchPath(item.activePath)"
            >
              <div>{{ item.activeName }}</div>
              <i class="el-icon-close" @click="removeTag(index, item)"></i>
            </el-tag>
          </div>-->
        </div>
        <div class='rightBox'>
          <div class='user-info'>
            <span>
            <img v-if="gender === 'MAN'" class='user_img' src='@/assets/user1.png' alt />
            <img v-if="gender === 'WOMAN'" class='user_img' src='@/assets/user2.png' alt />
            {{ userName }}
          </span>
            <el-tooltip content='退出登录' placement='top'>
              <el-button class='logout' icon='el-icon-switch-button' @click.native='logout'></el-button>
            </el-tooltip>
          </div>
        </div>

      </el-header>
      <!--内容主体-->
      <el-container>
        <!--菜单列表-->
        <el-aside :width="isCollapse ? '52px' : '240px'" :style='{height: contentStyleObj.height}'>
          <el-menu
            :collapse='isCollapse'
            text-color='#DADADE'
            active-text-color='#3e5deb'
            unique-opened
            :collapse-transition='false'
            :router='true'
            :default-active='activePath'>
            <span v-for='item in menuList'
                  :key='item.id'>
              <span v-if='item.menuChildList.length===0'>
                   <el-menu-item
                     :index="'/' + item.router + ''"
                     :key='item.id'
                     @click="saveNavState('/' + item.router, item.name,item.badgeKey)">
                          <!-- 二级菜单模板 -->
                          <template slot='title'>
                            <!-- 二级菜单字体 -->
                            <i :class='item.icon'></i>
                            <!-- 二级菜单文本 -->
                            <el-badge
                              v-if='item.badgeKey'
                              :value='getBadge(item.badgeKey)'
                              :max='99'
                              class='item'
                            >
                              <span>{{ item.name }}</span>
                            </el-badge>
                            <span v-else>{{ item.name }}</span>
                          </template>
                  </el-menu-item>
              </span>
              <el-submenu
                v-if='item.menuChildList.length >0'
                class='submenu'
                :index="item.id + ''">
              <!--如果有子菜单-->
              <template slot='title'>
                <!-- 图标 -->
                <i :class='item.icon'></i>
                <!-- 文本 -->
                <el-badge
                  v-if='item.badgeKey'
                  :value='getBadge(item.badgeKey)'
                  :max='99'
                  class='item'
                >
                  <span>{{ item.name }}</span>
                </el-badge>
                <span v-else>{{ item.name }}</span>
              </template>
                <!-- 二级菜单 -->
              <el-menu-item
                :index="'/' + subitem.router + ''"
                v-for='subitem in item.menuChildList'
                :key='subitem.id'
                @click="saveNavState('/' + subitem.router, subitem.name,subitem.badgeKey)">
                <!-- 二级菜单模板 -->
                <template slot='title'>
                  <!-- 二级菜单字体 -->
                  <i :class='subitem.icon'></i>
                  <!-- 二级菜单文本 -->
                  <el-badge
                    v-if='subitem.badgeKey'
                    :value='getBadge(subitem.badgeKey)'
                    :max='99'
                    class='item'
                  >
                    <span>{{ subitem.name }}</span>
                  </el-badge>
                  <span v-else>{{ subitem.name }}</span>
                </template>
              </el-menu-item>
            </el-submenu>
            </span>
          </el-menu>
        </el-aside>

        <!--内容区域-->
        <el-main :style='{height: contentStyleObj.height}'>
          <!-- 路由占位符 -->
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { selectAllMenu } from '@/api/user/menu/menu'


export default {
  data() {
    return {
      menuList: [],
      message_visible: false,
      // 被激活的链接地址
      activePath: '',
      userName: '',
      tabList: [],
      adminUrl: '',
      isCollapse: false,
      gender: '',
      totalMessagesCount: 0,
      messageIds: [],
      allMessageIds: [],
      queryInfo: {
        current: 1,
        size: 100
      },
      contentStyleObj: {
        height: '',
        width: ''
      }
    }
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
    const userinfo = sessionStorage.getItem('userinfo')
    this.activePath = window.sessionStorage.getItem('activePath')
    if (userinfo) {
      this.gender = JSON.parse(userinfo).loginUser.sex
    } else {
      const a = Cookies.get('loginInfo')
      this.gender = JSON.parse(a).loginUser.sex
    }
    this.getMenuList()
    this.initialize()
  },
  methods: {
    //初始化路由
    initialize() {
      const arr = JSON.parse(sessionStorage.getItem('tabList'))
      this.tabList = arr ? arr : []
    },

    //获取浏览器的宽高
    getHeight() {
      this.contentStyleObj.height = window.innerHeight - 60 + 'px'
      this.contentStyleObj.width = window.innerWidth - 250 + 'px'
    },

    // 退出登录
    logout() {
      this.$confirm('确定退出吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let userinfo = sessionStorage.getItem('userinfo')
        const b = JSON.parse(userinfo)
        if (b.loginUser.enumType === 'INSIDE') {
          this.$store.dispatch('auth/logout')
          this.$router.push(`/login`)
        }
      }).catch(() => {
      })

    },

    home() {
      this.$router.push('/home')
    },

    saveNavState(activePath, activeName) {
      window.sessionStorage.setItem('activePath', activePath)
      window.sessionStorage.setItem('activeName', activeName)
      this.activePath = activePath
      const arr = {
        activePath: activePath,
        activeName: activeName
      }
      let flag = true
      this.tabList.forEach((c) => {
        if (c.activePath === arr.activePath) {
          return flag = false
        }
      })
      if (flag) {
        this.tabList.push(arr)
      }
      if (activePath === this.$route.path) {
        this.$router.go(0)
      }
      sessionStorage.setItem('tabList', JSON.stringify(this.tabList))
    },

    //tab页跳转
    switchPath(activePath) {
      if (activePath === this.$route.path) {
        this.$router.go(0)
      }
      this.$router.push(`${activePath}`)
      this.activePath = activePath
    },

    //删除一个tab
    removeTag(index) {
      this.tabList.splice(index, 1)
      sessionStorage.setItem('tabList', JSON.stringify(this.tabList))
      if (this.tabList.length === 0) {
        this.$router.push(`/welcome`)
      }
    },

    // 获取数据列表 菜单列
    getMenuList() {
      selectAllMenu(this.queryInfo).then(res => {
        this.menuList = res.code === '0' ? res.data.records : []
        this.userName = sessionStorage.getItem('uname')
      })
    }
  }
}
</script>

<style lang='less' scoped>
.leftBox {
  width: 85%;
}

.rightBox {
  width: 15%;
  text-align: right;

  .tips {
    width: 35%;
    float: left;
  }

  .user-info {
    width: 65%;
    float: left;
  }
}

.redIcon {
  display: block;
  border-radius: 50%;
  width: 6px;
  height: 6px;
  top: 26px;
  right: 86px;
  background-color: red;
  position: absolute;
}

/deep/ .el-submenu__title {
  font-size: 12px;
}

/deep/ .el-submenu [class^='el-icon-'] {
  font-size: 20px;
}

/deep/ .el-menu-item {
  font-size: 12px;
}

.popover {
  .emptyMessage {
    color: #999999;
    text-align: center;
    font-size: 15px;
  }

  .list {
    overflow: hidden;

    .lie {
      height: 45px;
      padding-bottom: 10px;
      border-bottom: 1px solid #f5f5f5;
      margin-bottom: 10px;
      background-color: #ffffff;

      .lieTitle {
        font-size: 13px;
        color: #333333;
        font-weight: 500;
      }

      .lieContent {
        font-size: 11px;
        color: #666666;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin: 5px 0px;
      }

      .lieTime {
        color: #999999;
        font-size: 10px;
      }
    }

    .lie:hover {
      background-color: #f5f5f5;
    }
  }

  .bottomFooter {
    padding-top: 5px;
    margin-top: 15px;
    border-top: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;

    .footer {
      cursor: pointer;
      display: flex;
      justify-content: space-between;
    }
  }
}

/deep/ .el-submenu .el-menu-item {
  height: 52px;
}

.submenu {
  /deep/ .el-badge__content.is-fixed {
    top: 10px;
    right: -21px;
  }
}

.el-menu-item:focus,
.el-menu-item:hover {
  &:hover {
    border-right: 2px solid #3e5deb;
  }
}

.logout {
  &:hover {
    background-color: #fff;
  }

  &:focus {
    background-color: #fff;
  }
}

/deep/ .el-icon-switch-button {
  font-size: 16px;
  color: red;
}

.cutton {
  color: #3e5deb !important;
}

/deep/ .el-header {
  padding-left: 5px;
  background-color: #fff;
  color: #333;
  line-height: 60px;
  font-size: 14px;
  border-bottom: 1px solid #e6e6e6;

  .left {
    padding-right: 20px;
    height: 60px;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: auto;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(237, 242, 247, 1);
      background: rgba(0, 0, 0, 0.2);
    }

    &::-webkit-scrollbar-track {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(204, 215, 236, 1);
      background: rgba(0, 0, 0, 0.1);
    }

    .el-tag {
      position: relative;
      background-color: #fff;
      margin-right: 15px;
      cursor: pointer;
      color: #787878;
      padding-right: 20px;
      border: 1px solid transparent;

      &:hover {
        border: 1px solid #3e5deb;
      }

      &:hover i {
        display: block;
      }

      i {
        display: none;
        position: absolute;
        font-size: 12px;
        top: 4px;
        right: 0;
      }
    }
  }

  .el-dropdown {
    float: right;
  }

  .logo {
    float: left;
    width: 150px;
    height: 60px;
    line-height: 60px;
    text-align: center;

    > img {
      height: 25px;
      vertical-align: middle;
    }
  }

  .user_img {
    width: 24px;
    height: 24px;
    vertical-align: middle;
    border-radius: 13px;
    margin: 0 8px;
    margin-bottom: 8px;
  }

  .toggle-button {
    float: left;
    line-height: 40px;
    cursor: pointer;

    &:hover {
      background-color: #fff;
    }

    &:focus {
      background-color: #fff;
    }
  }
}

/deep/ .el-aside {
  transition: width 300ms;
  -webkit-transition: width 300ms;
  position: relative;
  z-index: 999;

  .el-menu {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #304156;
  }

  .el-menu::-webkit-scrollbar {
    width: 6px;
  }

  .el-menu::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(237, 242, 247, 1);
    background: rgba(0, 0, 0, 0.2);
  }

  .el-menu::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(204, 215, 236, 1);
    background: rgba(0, 0, 0, 0.1);
  }
}

/deep/ .el-dropdown-menu {
  width: 80px;
}

[class*=' el-icon-'],
[class^='el-icon-'] {
  font-size: 24px;
}

.el-icon-arrow-down:before {
  font-size: 12px;
}

/deep/ .el-badge__content {
  margin-top: 16px;
  margin-right: 18px;
}

.el-button {
  border: none;
}

.el-icon-arrow-down:before {
  font-size: 12px;
}

/deep/ .el-badge__content {
  margin-top: 16px;
  margin-right: 18px;
}

/deep/ .el-main {
  padding: 0;
  background-color: #f4f6fa;
  overflow: hidden;
}
</style>
